import { useAuth } from "./useAuth";

/* 데일리 미션 GET 훅 */
export default function useDailyMission() {
  const { api } = useAuth();

  const ZERO_STATE = {
    today_tasks: [],
    tomorrow_tasks: [],
    week_high_priority: [],
    today_count: 0,
    tomorrow_count: 0,
    week_high_count: 0,
    unsolved_task_count: 0,
    footprints: 0,
  };

  /* /api/v1/dashboard/daily/mission 호출 */
  const getDailyMission = async () => {
    try {
      const { data } = await api.get("dashboard/daily/mission");

      const status = data?.status ?? false;
      const payload = data?.data ?? {};

      if (!status) {
        return {
          status: false,
          data: { ...ZERO_STATE },
        };
      }

      return {
        status: true,
        data: {
          today_tasks: payload.today_tasks ?? [],
          tomorrow_tasks: payload.tomorrow_tasks ?? [],
          week_high_priority: payload.week_high_priority ?? [],
          today_count: payload.today_count ?? 0,
          tomorrow_count: payload.tomorrow_count ?? 0,
          week_high_count: payload.week_high_count ?? 0,
          unsolved_task_count: payload.unsolved_task_count ?? 0,
          footprints: payload.footprints ?? 0,
        },
      };
    } catch (e) {
      // 네트워크/서버 에러 시도 동일 처리
      return {
        status: false,
        data: { ...ZERO_STATE },
      };
    }
  };

  return { getDailyMission };
}
